// Copyright (c) 2026 Otyka LLC. All rights reserved.

/**
 * Applies a tenant's branding (color scheme) to the :root CSS variables at runtime.
 */

const COLOR_SCHEMES = {
  'classic-green': {
    '--green-dark': '#1a472a',
    '--green-mid': '#2d6a4f',
    '--green-light': '#52b788',
    '--gold': '#c9a84c',
    '--gold-light': '#e8c97a',
    '--cream': '#faf7f2',
  },
  'navy-gold': {
    '--green-dark': '#0d2b4e',
    '--green-mid': '#1a4a7a',
    '--green-light': '#1a6eb5',
    '--gold': '#d4a843',
    '--gold-light': '#e8c97a',
    '--cream': '#f5f7fa',
  },
  'burgundy-silver': {
    '--green-dark': '#6b1a2a',
    '--green-mid': '#8c2438',
    '--green-light': '#c45070',
    '--gold': '#9e9e9e',
    '--gold-light': '#bdbdbd',
    '--cream': '#fdf5f6',
  },
  'slate-copper': {
    '--green-dark': '#2c3e50',
    '--green-mid': '#3d5166',
    '--green-light': '#546e7a',
    '--gold': '#b87333',
    '--gold-light': '#d4956a',
    '--cream': '#f4f6f8',
  },
  'forest-cream': {
    '--green-dark': '#1b3a2d',
    '--green-mid': '#2e6b4f',
    '--green-light': '#8fbc8f',
    '--gold': '#c9a84c',
    '--gold-light': '#e8c97a',
    '--cream': '#f8f6f0',
  },
  'black-gold': {
    '--green-dark': '#1a1a1a',
    '--green-mid': '#2d2d2d',
    '--green-light': '#555555',
    '--gold': '#c9a84c',
    '--gold-light': '#e8c97a',
    '--cream': '#f8f6f0',
  },
};

export function applyTenantTheme(branding) {
  if (!branding) return;

  const root = document.documentElement;
  const schemeId = branding.colorScheme || 'classic-green';
  const vars = COLOR_SCHEMES[schemeId];

  if (vars) {
    Object.entries(vars).forEach(([k, v]) => root.style.setProperty(k, v));
  }
}
